var MeasurementsSort;
(function (MeasurementsSort) {
    MeasurementsSort["ALPHABETICAL"] = "alpha";
    MeasurementsSort["TIME"] = "time";
})(MeasurementsSort || (MeasurementsSort = {}));
export default MeasurementsSort;
